import { FC } from 'react';
import { createPortal } from 'react-dom';
import { useSnackbarStack } from '../../../providers/SnackbarProvider.tsx';
import Snackbar from './core/Snackbar.tsx';

const SnackbarStack: FC = () => {
  const { stack, removeSnackbar } = useSnackbarStack();

  return createPortal(
    <div className="w-fit min-w-[343px] fixed bottom-[32px] right-[32px] z-[10000] flex flex-col items-end gap-y-2">
      {stack.slice(-3).map(({ id, ...props }) => (
        <Snackbar key={id} onClose={() => removeSnackbar(id)} {...props} />
      ))}
    </div>,
    document.body,
  );
};

export default SnackbarStack;
